import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { useAppSelector } from '../../store/hooks';
import { TavernErrorBoundary, TavernToast } from '../../ui/components';

export function FormShell() {
  const rulesAccepted = useAppSelector((s) => s.app.rulesAccepted);
  const user = useAppSelector((s) => s.auth.user);
  const location = useLocation();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (!rulesAccepted && location.pathname !== '/') {
      navigate('/', { replace: true });
    }
  }, [location.pathname, navigate, rulesAccepted]);

  React.useEffect(() => {
    if (rulesAccepted && !user && location.pathname !== '/') {
      navigate('/', { replace: true });
    }
  }, [location.pathname, navigate, rulesAccepted, user]);

  return (
    <div className="ttbShell ttbShellNoNav">
      <TavernToast />
      <main className="ttbShellMain">
        <TavernErrorBoundary>
          <Outlet />
        </TavernErrorBoundary>
      </main>
    </div>
  );
}
